<ng-template #scenarioTemp>
  <button class="btn btn--blue pl-3 text-sm" (click)="createScenario()">
    <aux-icon name="Plus" />
    Create New Scenario
  </button>
</ng-template>

<div class="mb-4 border-b pb-2 pt-2 text-sm">Scenarios</div>

<div class="grid grid-cols-4 gap-10 whitespace-nowrap text-xs">
  @for (scenario of scenarios; track scenario) {
    <div class="rounded border p-4">
      <div class="mb-2 text-sm font-bold leading-5 text-aux-blue">{{ scenario.header }}</div>
      <div class="mb-1 mt-1 flex">{{ scenario.row1 }}</div>
      <div class="mb-1 mt-1 flex">{{ scenario.row2 }}</div>
      <div class="mb-1 mt-1 flex">{{ scenario.row3 }}</div>

      <div class="mt-4 flex justify-between">
        <button class="font-medium text-aux-blue underline">View/Edit</button>

        <div class="flex items-center font-medium">
          <aux-checkbox />
          Compare
        </div>
      </div>
    </div>
  }
</div>

<div class="mb-4 mt-16 border-b pb-2 pt-2 text-sm">Vendor Budgets</div>

<div class="mb-4 flex items-center space-x-2 text-xs">
  <span>Vendor Contract</span>
  <ng-select class="inline-block w-32" />
</div>

<div class="grid grid-cols-4 gap-5 whitespace-nowrap text-xs">
  @for (budget of budgets; track budget) {
    <div class="rounded border p-4">
      <div class="mb-2 text-sm font-bold leading-5 text-aux-blue">{{ budget.header }}</div>
      <div class="mb-1 mt-1 flex">{{ budget.row1 }}</div>
      <div class="mb-1 mt-1 flex">{{ budget.row2 }}</div>
      <div class="mb-1 mt-1 flex">{{ budget.row3 }}</div>

      <div class="mt-4 flex justify-between">
        <button class="font-medium text-aux-blue underline">View/Edit</button>

        <div class="flex items-center font-medium">
          <aux-checkbox />
          Compare
        </div>
      </div>
    </div>
  }
</div>
